import SolicitacaoPagamentoEstrangeiroPf from './componentes/SolicitacaoPagamentoEstrangeiroPf.vue';
import SolicitacaoPagamentoEstrangeiroPfLista from './componentes/SolicitacaoPagamentoEstrangeiroPfLista.vue';
import SolicitacaoPagamentoEstrangeiroPfForm from './componentes/SolicitacaoPagamentoEstrangeiroPfForm.vue';
import SolicitacaoPagamentoEstrangeiroPfRelatorio from './componentes/SolicitacaoPagamentoEstrangeiroPfRelatorio.vue';

export default {
  path: '/solicitacao-pagamento-estrangeiro-pf',
  component: SolicitacaoPagamentoEstrangeiroPf,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoPagamentoEstrangeiroPfLista,
      name: 'solicitacao-pagamento-estrangeiro-pf',
    },
    {
      path: 'nova',
      component: SolicitacaoPagamentoEstrangeiroPfForm,
      name: 'solicitacao-pagamento-estrangeiro-pf.nova',
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoPagamentoEstrangeiroPfRelatorio,
      name: 'solicitacao-pagamento-estrangeiro-pf.relatorio'
    },
    {
      path: ':idCript',
      component: SolicitacaoPagamentoEstrangeiroPfForm,
      name: 'solicitacao-pagamento-estrangeiro-pf.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-pagamento/estrangeiro-pf/rotas.js